import { Box, Button, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import Table, { ColumnType } from "components/Table";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { ResType } from "types";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFilters } from "redux/reducers/taskboardSlice";
import { Visibility } from "@mui/icons-material";
import {
  exportClientTempNoticeFYI,
  getClientExcelproceedingFyi,
  getExcelFyiSections,
  getIncomeTaxProfile,
} from "api/services/automation/income-tax";
import AccessDenied from "./Access/accessDenide";
import Loader from "components/Loader";
import { resetState } from "redux/reducers/clientsSlice";
import DateRange from "views/dashboard/OrgDashboard/DateRange";
import { eProFyiCaseStaus, getAutFinancialYears } from "pages/atom-pro/constants";
import SearchContainer from "components/SearchContainer";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";

const ClientTempNoticeFyi = (state) => {
  useTitle("ATOM Pro | Clients");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const dispatch = useDispatch();
  const params = useParams();
  const [section, setSection] = useState<any>(null);
  const [assessmentYear, setAssessmentYear] = useState<any>(null);
  const [sections, setSectionData] = useState<any>(null);
  const [caseStatus, setCaseStatus] = useState<any>(null);
  const [dates, setDates] = useState({ fromDate: null, toDate: null });
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
      dispatch(resetState());
    };
  }, []);
  const [checkAccess, setCheckAccess] = useState(true);
  const { data, isLoading }: ResType = useQuery(
    [
      "client-proceedingfyi-excel",
      params.incometaxid,
      {
        limit: pageCount,
        offset: page * pageCount,
        section: section,
        assessmentYear: assessmentYear,
        caseStatus: caseStatus,
        search: search,
        ...dates,
        sort
      },
    ],
    getClientExcelproceedingFyi,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
        setCheckAccess(res?.data?.accessDenied);
      },
    }
  );

  const onChange = (e: any) => {
    setSection(e.target.value);
    setPage(0);
  };

  const onStatusChange = (e: any) => {
    setCaseStatus(e.target.value);
    setPage(0);
  };

  const onAssessmentYearChange = (e: any) => {
    setAssessmentYear(e.target.value);
    setPage(0);
  };

  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };

  const { data: sectionData, isLoading: sectionIsloading }: ResType = useQuery(
    ["excel-e-proceedings-sections"],
    getExcelFyiSections,
    {
      onSuccess: (res) => {
        setSectionData(res?.data);
      },
    }
  );

  const { data: profiledata, isLoading: isprofileloading }: ResType = useQuery(
    ["get-income-tax-profile", params.incometaxid],
    getIncomeTaxProfile,
  );
  const clientName = profiledata?.data?.profileDetails?.name;
  const { mutate: mutate1 } = useMutation(exportClientTempNoticeFYI, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - ${clientName} Income Tax (PAN) e-Proceedings Excel (For Your Information) ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax e-proceedings (FYI) exported sucessfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const handleExport = () => {
    mutate1({
      incometaxid: params.incometaxid,
      limit: pageCount,
      offset: page * pageCount,
      section,
      assessmentYear,
      caseStatus,
      search,
      ...dates,
    });
  };

  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  if (isLoading) return <Loader />;
  return (
    <>
      <Box m={1}>
        {!checkAccess && <AccessDenied />}
        
        {checkAccess && (
          <>
            <Box mb={1} display="flex" alignContent="center" mt={2}>
              <TextField
                name="assessmentYear"
                value={assessmentYear}
                onChange={onAssessmentYearChange}
                size="small"
                label="Assessment Year"
                select
                sx={{ width: "150px", marginRight: "20px" }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                <MenuItem key={""} value={"null"}>
                  NA
                </MenuItem>
                {getAutFinancialYears().map((year: string) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                name="section"
                value={section}
                onChange={onChange}
                size="small"
                label="Section"
                select
                sx={{ width: "100px", marginRight: "20px" }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                <MenuItem key={""} value={"null"}>
                  NA
                </MenuItem>
                {sections?.map((option: any, index: any) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                name="caseStatus"
                value={caseStatus}
                onChange={onStatusChange}
                size="small"
                label="Case Status"
                select
                sx={{ width: "100px", marginRight: "20px" }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                {eProFyiCaseStaus?.map((option: any, index: any) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              <SearchContainer
                debounced
                value={search}
                placeHolder="Search by Proceeding Name"
                onChange={handleSearch}
                maxWidth="250px"
                width="250px"
                minWidth="350px"
              />
              <Box ml={1}>
                <DateRange dates={dates} setDates={setDates} setPage={setPage} />
              </Box>
              <Button
                sx={{ marginLeft: 2 }}
                onClick={() => {
                  setSection("");
                  setAssessmentYear(null);
                  setSearch("");
                  setDates({ fromDate: null, toDate: null });
                }}
                size="small"
                color="secondary"
                variant="outlined"
              >
                Clear Filters
              </Button>
              <Box display="flex" justifyContent="flex-end" ml={2}>
          <Button variant="outlined" color="secondary" onClick={handleExport}
            startIcon={<FileDownloadOutlinedIcon />}>
            Export
          </Button>
        </Box>
              {/* <Button variant="outlined" color="secondary" onClick={handleExport}
                                startIcon={<FileDownloadOutlinedIcon />}
                                sx={{ marginLeft: 2 }}
                              >
                                Export
                              </Button> */}
              <Box>{/* <ClientsHeader search={search} setSearch={setSearch} /> */}</Box>
            </Box>
            <Table
              sx={{ pb: 0, mb: 0, height: "440px" }}
              pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
              data={data?.data?.result || []}
              columns={columns}
              sortHandler={handleSort}
              loading={isLoading}
            />
          </>
        )}
      </Box>
    </>
  );
};

const generateAssessmentYear = (assessmentYear) => {
  if (!assessmentYear || assessmentYear === "0" || assessmentYear === "") {
    return "NA";
  } else if (!isNaN(assessmentYear) && assessmentYear.length === 4) {
    const year = parseInt(assessmentYear);
    const nextYear = (year + 1).toString().slice(-2);
    return `AY ${year}-${nextYear}`;
  } else {
    return assessmentYear;
  }
};

const defaultColumns: Array<ColumnType> = [
  {
    key: "ay",
    title: "Assessment Year",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.ay === "0-01" ? "NA" : v?.ay}</Typography>,
  },
  {
    key: "type",
    title: "Type",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
  },
  {
    key: "noticeSentDate",
    title: "Notice Sent Date",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.noticeSentDate ? v.noticeSentDate : "--"}</Typography>,
  },
  {
    key: "proceedingName",
    title: (
      <Box display="flex" alignItems="center">
        Proceeding Name
      </Box>
    ),
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.proceedingName ? v?.proceedingName : "--"}</Typography>,
  },

  // {
  //   key: "",
  //   title: "Concluded Date",
  //   render: (v) => (
  //     <Typography
  //     // variant="subtitle2"
  //     // sx={{
  //     //   display: "inline-block",
  //     //   padding: "0px 5px",

  //     //   color: "#222222",
  //     //   fontSize: "12px",
  //     // }}
  //     >
  //       {v?.proceedingConcludedDate === "null" ? "--" : v.proceedingConcludedDate}
  //     </Typography>
  //   ),
  // },
  {
    key: "proceedingStatus",
    title: "Proceeding Status",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.proceedingStatus ? v.proceedingStatus : "--"}</Typography>,
  },
  {
    key: "noticeDin",
    title: "Notice DIN",
    render: (v) => <Typography>{v.noticeDin}</Typography>,
  },

  {
    key: "dateOfCompliance",
    title: "Compliance Date",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.dateOfCompliance ? v.dateOfCompliance : "--"}</Typography>,
  },
  {
    key: "dateResponseSubmitted",
    title: "Response Submitted",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => (
      <Typography>{v?.dateResponseSubmitted ? v.dateResponseSubmitted : "--"}</Typography>
    ),
  },
  {
    key: "noticeSection",
    title: "Section",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => <Typography>{v?.noticeSection ? v.noticeSection : "--"}</Typography>,
  },
  {
    key: "proceedingLimitationDate",
    title: "Limitation Date",
    sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,
    render: (v) => (
      <Typography>
        {v?.proceedingLimitationDate === "null" || v?.proceedingLimitationDate === null
          ? "--"
          : v.proceedingLimitationDate}
      </Typography>
    ),
  },

  // {
  //   key: "",
  //   title: "Action",
  //   render: (rowData: any) => <Actions data={rowData} />,
  // }
];

function Actions(props: any) {
  const navigate = useNavigate();

  const handleViewMoreClick = () => {
    navigate(`/atom-pro/income-tax/proceeding-information/${props.data?.id}`);
  };

  return (
    <IconButton onClick={handleViewMoreClick} size="small">
      <Visibility />
    </IconButton>
  );
}

export default ClientTempNoticeFyi;
